import React, { useRef } from 'react';
import { ArrowLong } from '../../../../assets/img/svg/icons';

import Input from '../../../Components/input';
import Textarea from '../../../Components/textarea';
import Swal from 'sweetalert2';
import { sendFormData } from '../../../../Api';

const ContactForm: React.FC = () => {
    const formRef = useRef<HTMLFormElement>(null);
    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
    
        if (formRef?.current) {
          const formData = new FormData(formRef?.current);
    
          const data = {
            name: formData.get("nome"),
            email: formData.get("email"),
            phone: formData.get("celular"),
            subject: formData.get("assunto"),
            message: formData.get("mensagem"),
          };

          if(!data.name){
            Swal.fire({
              title: "Aviso!",
              text: "Preencha seu nome!",
              icon: "warning",
              confirmButtonText: "OK",
            });
            return ;
          }
          if(!data.email){
            Swal.fire({
              title: "Aviso!",
              text: "Preencha seu e-mail!",
              icon: "warning",
              confirmButtonText: "OK",
            });
            return ;
          }
          if(!data.phone){
            Swal.fire({
              title: "Aviso!",
              text: "Preencha seu telefone!",
              icon: "warning",
              confirmButtonText: "OK",
            });
            return ;
          }
          if(!data.subject){
            Swal.fire({
              title: "Aviso!",
              text: "Preencha o assunto!",
              icon: "warning",
              confirmButtonText: "OK",
            });
            return ;
          }
          if(!data.message){
            Swal.fire({
              title: "Aviso!",
              text: "Preencha sua mensagem!",
              icon: "warning",
              confirmButtonText: "OK",
            });
            return ;
          }
    
          try {
            //await sendFormData("contato", data);
            
            Swal.fire({
              title: "Sucesso!",
              text: "Mensagem enviada com sucesso.",
              icon: "success",
              confirmButtonText: "OK",
            });
          } catch (error) {
            Swal.fire({
              title: "Erro!",
              text: "Ocorreu um erro ao enviar a mensagem.",
              icon: "error",
              confirmButtonText: "Tentar novamente",
            });
          }
        }
    };
    return (
        <section className="py-8">
            <div className="max-w-screen-lg mx-auto px-4">
                <div className="relative z-10 after:content-[''] after:w-[calc(100%+2rem)] lg:after:w-[calc(100%+6rem)] after:h-56 after:bg-main-yellow after:absolute after:-top-14 after:left-1/2 after:-translate-x-1/2 lg:after:rounded-3xl after:-z-10 before:content-[''] before:h-56 before:w-[calc(100%+2rem)] lg:before:w-[calc(100%+6rem)] before:-top-14 before:left-1/2 before:-translate-x-1/2 before:bg-main-blue/50 before:rounded-3xl before:absolute md:before:-rotate-2 before:-rotate-3 before:-z-10 before:hidden lg:before:block">

                    <form action="" onSubmit={handleSubmit} ref={formRef} className="bg-white shadow-form rounded-lg px-8 py-8 lg:py-14 relative z-10 drop-shadow-lg">
                        <h2 className="font-semibold text-center mb-4 text-2xl">
                            Fale com nossa equipe
                        </h2>

                        <p className="text-center text-sm max-w-[500px] mx-auto">
                            Em caso de dúvidas, ou se quiser receber mais informações sobre nossos eventos, preencha o formulário abaixo.
                        </p>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4 lg:mt-8 mx-auto max-w-3xl">
                            <div className="col-span-1 lg:col-span-2">
                                <Input name="nome" id="nome" type="text" desc="Nome:" required />
                            </div>

                            <div className="col-span-1 lg:col-span-2">
                                <Input name="email" id="email" type="email" desc="E-mail:" required />
                            </div>

                            <div className="col-span-1">
                              <Input name="celular" id="cel" type="text" desc="Celular:" mask="(99) 99999-9999" required />
                            </div>

                            <div className="col-span-1">
                                <Input name="assunto" id="assunto" type="text" desc="Assunto:" required />
                            </div>

                            <div className="col-span-1 lg:col-span-2">
                                <Textarea name="mensagem" id="mensagem" desc="Mensagem:" required />
                            </div>

                            <div className="col-span-1 lg:col-span-2">
                                <div className="mt-6 max-w-56">
                                    <button className="bg-main-pink rounded-full text-center gap-3 inline-flex justify-center items-center p-4 uppercase text-sm font-semibold transition-all duration-200 w-full hover:bg-main-yellow text-white" type="submit">
                                        Enviar mensagem
                                        <ArrowLong />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default ContactForm;
